export enum BorrowerType {
  Borrower = 'borrower',
  CoBorrower = 'coBorrower',
}
